 //import { Configuration } from 'src/app/Utilities/configurations';
 import * as CryptoJS from 'crypto-js'; 
 //var Configuration = require('src/assets/app-config.json');
 import { configuration } from 'src/environments/environment';
 import { stringify } from '@angular/compiler/src/util';
import { Defaults } from '../defaults';
export class AESAlgorithm
{
  key;
  iv;
  encodedString : string;
  encryptor(plainText : string)
   {
      try
      {
        this.key = CryptoJS.enc.Utf8.parse(configuration.key);  
        this.iv = CryptoJS.enc.Utf8.parse(configuration.iv); 
        // this.iv=configuration.key.toString().substring(8,24);
        // this.iv=CryptoJS.enc.Utf8.parse(this.iv);
        this.encodedString = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(plainText), this.key,  
         {
         keySize: 128 / 8,   
         iv: this.iv,  
         mode: CryptoJS.mode.CBC,  
         padding: CryptoJS.pad.Pkcs7 
         }); 
         return this.encodedString.toString() ;
      }
      catch(e){

      }
  
    return plainText ;

   }
   
   encryptPassword(plainText : string, pwdkey : any)
   {
   
    this.key = CryptoJS.enc.Utf8.parse(pwdkey);  
    this.iv = CryptoJS.enc.Utf8.parse(pwdkey.substring(0,16)); 
   //this.iv=this.key.toString().substring(8,24);
    this.encodedString = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(plainText), this.key,  
     {
     keySize: 128 / 8,   
     iv: this.iv,  
     mode: CryptoJS.mode.CBC,  
     padding: CryptoJS.pad.Pkcs7 
     });  
     return this.encodedString ;
 
    
   }

   urlParmeterEncoder(data) {

    try {
      return CryptoJS.AES.encrypt(JSON.stringify(data), configuration.key).toString();
    } catch (e) {
      console.log(e);
    }
  }

  urlParmeterDecoder(data) {

    try {
      const bytes = CryptoJS.AES.decrypt(data, configuration.key);
      if (bytes.toString()) {
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      }
      return data;
    } catch (e) {
      console.log(e);
      return data;
    }
  }

  encryptphoneandtext(normaltxt:string):string {
    let key = CryptoJS.enc.Utf8.parse("Gr3@tW@t3rS@lt@1B2c3D4e5F6g7H8");
    let iv = CryptoJS.enc.Utf8.parse("f3a27857e90e1b97");
    let encrypted:string = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(normaltxt), key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    return encrypted
  }

  //for request encyption
  reqencodedString;
  reqencryptor(plainText : string)
   {
      try
      {     
        
        var defaultEncryptedKey=Defaults.EncryptionKey? Defaults.EncryptionKey: '78394567263485273854369834359345';
        this.key = CryptoJS.enc.Utf8.parse(defaultEncryptedKey);  
        //this.iv = CryptoJS.enc.Utf8.parse(configuration.iv); 
         this.iv=defaultEncryptedKey.toString().substring(8,24);
         this.iv=CryptoJS.enc.Utf8.parse(this.iv);
        this.reqencodedString = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(plainText), this.key,  
         {
         keySize: 128 / 8,   
         iv: this.iv,  
         mode: CryptoJS.mode.CBC,  
         padding: CryptoJS.pad.Pkcs7 
         }); 
         return this.reqencodedString.toString() ;
      }
      catch(e){
      }
  
    return plainText ;

   }
}